import React, { useContext, useEffect, useState } from 'react';
import SearchTermInput from './SearchTermInput';
import { useTranslations } from 'next-intl';
import SearchFilterOptions from './SearchFilterOptions';
import { useRouter } from 'next/router';
import { assignValuesFromRouteQuery, pushValuesToRouteQuery, replaceValuesOfRouteQuery } from '@/utils';
import {
  AppInsightsContext,
  TrackEventKey,
  TrackEventName,
  TrackEventType,
} from '../azureAppInsights/AzureAppInsightsContext';
import { MetadataContext, UserContext } from '../ContextProviders';
import { CognitiveSearchResultModel, ReportSearchModel } from '@/types';

export type ReportsSearchFilterOptionType = {
  group: string;
  id: string;
  key: string;
  name: string;
  parentName: string;
  options?: ReportsSearchFilterOptionType[];
};

export type ReportsSearchFilterType = {
  id: string;
  key: string;
  name: string;
  disabled: boolean;
  options: ReportsSearchFilterOptionType[];
};

type SearchFiltersType = {
  filters: ReportsSearchFilterType[];
  publicSiteSearch: boolean;
  result: CognitiveSearchResultModel<ReportSearchModel>;
};

const SearchFilters = (data: SearchFiltersType) => {
  const { filters, publicSiteSearch, result } = data;
  const [searchTerm, setSearchTerm] = useState('');
  const t = useTranslations();
  const router = useRouter();
  const appInsights = useContext(AppInsightsContext);
  const { pageId } = useContext(MetadataContext);
  const user = useContext(UserContext);

  useEffect(() => {
    const searchTermFromQuery = { searchTerm: '' };
    assignValuesFromRouteQuery(router, searchTermFromQuery);
    setSearchTerm(searchTermFromQuery.searchTerm || '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.query]);

  useEffect(() => {
    const searchTermFromQuery = { searchTerm: '' };
    assignValuesFromRouteQuery(router, searchTermFromQuery);
    if (searchTermFromQuery.searchTerm) {
      appInsights.trackCustomEvent(TrackEventName.SEARCH_PAGE, TrackEventKey.SEARCH_REPORT, TrackEventType.NONE, user, {
        pageId,
        pagePath: router.asPath,
        searchTerm: searchTermFromQuery.searchTerm,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmit = () => {
    if (router.query.searchTerm !== searchTerm) {
      appInsights.trackCustomEvent(TrackEventName.SEARCH_PAGE, TrackEventKey.SEARCH_REPORT, TrackEventType.NONE, user, {
        pageId,
        pagePath: router.asPath,
        searchTerm,
      });
      pushValuesToRouteQuery(router, { searchTerm, page: null });
    }
  };

  const onClear = () => {
    replaceValuesOfRouteQuery(router, {});
  };

  return (
    <div className="bg-gray-2">
      <div className="container">
        <div className="px-4 py-5">
          <SearchTermInput
            placeholder={t('search.$searchbykeyword')}
            autofocus={false}
            value={searchTerm}
            onChange={(value) => setSearchTerm(value)}
            onSubmit={onSubmit}
            onClear={onClear}
          />
        </div>
      </div>
      <hr className="h-px border-0 bg-black/10" />
      <div className="container hidden py-6 md:block">
        <SearchFilterOptions availableFilters={filters} facets={result.facets} isPublic={publicSiteSearch} />
      </div>
    </div>
  );
};

export default SearchFilters;
